import type { InspectionTemplate } from 'inspection-types';

import type { CustomizationAction } from './actions';
import {
  createInitialState,
  type CustomizationState,
} from './customizationState';

function resolveExpansion(
  template: InspectionTemplate,
  current: Record<string, boolean>
): Record<string, boolean> {
  return Object.fromEntries(
    template.sections.map(section => [
      section.id,
      current[section.id] ?? !section.config?.collapsedByDefault,
    ])
  );
}

export function customizationReducer(
  state: CustomizationState,
  action: CustomizationAction
): CustomizationState {
  switch (action.type) {
    case 'IDENTITY_CHANGED':
      return createInitialState(action.identity);

    case 'REPLICA_LOAD_STARTED':
      return { ...state, replicaStatus: 'loading' };

    case 'REPLICA_LOADED':
      return {
        ...state,
        replica: action.template,
        replicaStatus: 'ready',
        expandedBySectionId: resolveExpansion(
          action.template,
          state.expandedBySectionId
        ),
      };

    case 'REPLICA_LOAD_FAILED':
      return { ...state, replicaStatus: action.failure };

    case 'SECTION_TOGGLED':
      return {
        ...state,
        expandedBySectionId: {
          ...state.expandedBySectionId,
          [action.sectionId]: !state.expandedBySectionId[action.sectionId],
        },
      };
  }
}
